
import { baseQuery } from "../baseQuery";
import { createAccountGroupMaster, deleteAccountGroupMaster, listAccountGroupMasterCustom, updateAccountGroupMaster } from "../../graphql";
import { createApi } from "@reduxjs/toolkit/dist/query/react";

export const listGroupMasterApi = createApi({
  reducerPath: "listGroupMasterApi",
  tagTypes: ["listGroupMaster"],
  baseQuery: baseQuery,
  endpoints: (builder) => ({
    listGroupMaster: builder.query({
      query: () => ({ body: listAccountGroupMasterCustom }),
      keepUnusedDataFor: 300,
      refetchOnMountOrArgChange: true,
      providesTags: ["listGroupMaster"],
    }),
    createAccountGroupMaster: builder.mutation({
      query: (variables) => ({ body: createAccountGroupMaster, variables }),
      invalidatesTags: ["listGroupMaster"],
    }),
    updateAccountGroupMaster: builder.mutation({
      query: (variables) => ({ body: updateAccountGroupMaster, variables }),
      invalidatesTags: ["listGroupMaster"],
    }),
    deleteAccountGroupMaster: builder.mutation({
      query: (variables) => ({ body: deleteAccountGroupMaster, variables }),
      invalidatesTags: ["listGroupMaster"],
    }),
  }),
});

export const { useListGroupMasterQuery, useCreateAccountGroupMasterMutation, useUpdateAccountGroupMasterMutation, useDeleteAccountGroupMasterMutation } = listGroupMasterApi;

